
<template lang="pug">
  include ./../../mixins
  +b.video-preview.bgi-basic(@click='showModal()' :class="{'cursor-pointer' : video}")
    +b.img-basic.IMG(:src='image')
    +b.video-button.position_absolute(v-if='video')
      +b.color_white.fs_xl.mdi.mdi-play
</template>

<script>
import VideoModal from "../Modal/VideoModal.vue"
export default {
  props: {
    video: {
      type: String
    },
    image: {
      type: String
    }
  },

  methods: {
    showModal() {
      if (this.video) {
        this.$modal.show(VideoModal, {
          src: this.video
        }, {
          classes: "modal modal--video",
          name: "video"
        })
      }
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/js/components/VideoBlock/VideoBlock.vue